import { render, staticRenderFns } from "./VueAutoComplete.vue?vue&type=template&id=342b65cc&"
import script from "./VueAutoComplete.vue?vue&type=script&lang=js&"
export * from "./VueAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports